export const deleteFailureMessage =
  "Delete failed. Please try again at a later time.";
